import { Injectable } from '@angular/core';
import { AppInitService } from 'src/app/app-init.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AppConfigurations } from 'src/app/shared/models/appConfiguration.model';import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { LWAReason } from '../models/left-without-assistant-reasion.model';
import { config } from 'process';
declare const window: any;

@Injectable({
  providedIn: 'root'
})
export class LWAReasonService {
  private lwaReasonsUrl: string = '';
  private appConfig!: AppConfigurations;

  constructor(private appInitService: AppInitService, private http: HttpClient) {
    appInitService.getAppConfiguration$().subscribe({
      next: (config) => this._onReceiveAppConfig(config)
    })    
  }
  
  private _onReceiveAppConfig(appConfig: AppConfigurations) {
    this.appConfig = appConfig;
    this.lwaReasonsUrl = `${this.appConfig.adminApi.baseApiUrl}${this.appConfig.adminApi.lwaReasonsController}`;
  }

  createLWAReason(newReason: LWAReason) {
    const url = `${this.lwaReasonsUrl}`;
    return this.http.post(url, newReason);
  }

  public getLwaReasons(): Observable<LWAReason[]> {
    const url = `${this.lwaReasonsUrl}`;
    return this.http.get<LWAReason[]>(url);
  }

  public updateLwaReasons(clickedRowItem: LWAReason) {
    const url = `${this.lwaReasonsUrl}/${clickedRowItem.id}`;
    return this.http.put(url, clickedRowItem);
  }

  public deleteLwaReasons(deletingItem: LWAReason) {
    const url = `${this.lwaReasonsUrl}/${deletingItem.id}`;
    return this.http.delete<any[]>(url);
  }
}
